export default __webpack_public_path__ + "static/media/C0005.901269e8.png";